// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rOnO","col":"styles_col__3o2m4"};